import {
  LayoutDashboard,
  Users,
  Package,
  FileText,
  BarChart3,
  Settings,
  ShoppingCart,
  Wallet,
  Coins,
  Boxes,
  ShieldCheck,
  Puzzle,
  ShoppingBag,
  CreditCard,
  Landmark,
  ReceiptText,
  type LucideIcon,
} from 'lucide-react';

/**
 * Mapea la CLAVE de icono que entrega el backend (string) al componente lucide.
 * Mantener en sync con los `icon` del module-registry del backend.
 */
const ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  pos: ShoppingCart,
  wallet: Wallet,
  file: FileText,
  coins: Coins,
  users: Users,
  package: Package,
  chart: BarChart3,
  settings: Settings,
  boxes: Boxes,
  'shopping-bag': ShoppingBag,
  'credit-card': CreditCard,
  bank: Landmark,
  expense: ReceiptText,
  admin: ShieldCheck,
};

export function iconFor(key: string): LucideIcon {
  return ICONS[key] ?? Puzzle;
}
